<template>
  <div class="mb-05">
    <div class="f-light break-word">
      <slot/>
      <span class="c-red ml-02" v-if="required">*</span>
      <span class="ml-01" v-else>(Optional)</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ElInputTitle',
  props: {
    required: Boolean
  }
};
</script>

<style lang="scss" scoped>
</style>
